import { styled as muiStyled } from '@mui/material/styles';
import styled from 'styled-components';

import { ReactComponent as TrashSvg } from 'assets/trash-icon.svg';
import { getSpacing, fontSize, letterSpacing, mediaQueriesBreakpoints, fontWeight } from 'stylesheetB2b';

const TRASH_ICON_SIZE = getSpacing(3);
const WAITING_LIST_ICON_SIZE = getSpacing(10);

interface TrashIconProps {
  $ishidden: boolean;
}

const headerMarginTop = `margin-top: ${getSpacing(3)};`;

export const SectionHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 0;
`;
SectionHeader.displayName = 'SectionHeader';

export const TrashIcon = styled(TrashSvg)<TrashIconProps>`
  width: ${TRASH_ICON_SIZE};
  height: ${TRASH_ICON_SIZE};

  ${headerMarginTop}
  @media (${mediaQueriesBreakpoints.portrait}) {
    visibility: visible;
  }
`;
TrashIcon.displayName = 'TrashIcon';

export const IconContainer = muiStyled('div')({
  width: WAITING_LIST_ICON_SIZE,
  height: WAITING_LIST_ICON_SIZE,
  color: 'inherit',
  overflow: 'visible',
  fontSize: fontSize.XXXLarge,
  textAlign: 'center',
  borderRadius: '50%',
  '@media (orientation: landscape)': {
    display: 'none',
  },
});

export const SectionTitle = muiStyled('h2')({
  flex: 1,
  letterSpacing: letterSpacing.normal,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: fontSize.small,
  fontWeight: fontWeight.bolder,
  marginTop: getSpacing(3),
  marginLeft: getSpacing(3),
  '@media (orientation: portrait)': {
    visibility: 'hidden',
  },
});

export const Duration = styled.span`
  flex-shrink: 0;
  font-size: ${fontSize.extraSmall};
  font-weight: ${fontWeight.light};
  ${headerMarginTop}
  margin-right: 0;
`;
Duration.displayName = 'Duration';
